/**
 * Created by roi on 24/02/17.
 */
import React, { Component } from 'react';

import '../../style/app.css';

import logoXOM from '../../images/logos/logo_XOM.png';

class Logo extends Component {
    render() {

        return (
            <div className="navbar-header logotips" style={{width: 'auto'}}>
                <img src={logoXOM} className="logo-XOM" alt="logo"/>
            </div>
        );
    }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/capcalera/logo.js